import { BookingProvider } from "@common/constans";
import { IDictionary } from "@common/models";
import { ISetting } from "@common/models/CMS";
import { store } from "@misc/Reducer";
import Config from "@service/Config";

export enum MapType { Google = 1, Leaflet }

export interface IPaginationConfig {
    itemsPerPage: number;
}

export interface IFileUpload {
    allowedExtentions: string;
    maxFilesCount: number;
    maxFileSize: number;
}

export interface ITransitionConfig {
    enter: number;
    leave: number;
}

export interface IVersion {
    api: string;
    app: string;
}

export interface IViewport {
    large: number;
    medium: number;
    small: number;
}

export interface ISizing {
    top: string;
    bottom: string;
}

interface ITypography {
    defaultPadding: ISizing;
}

interface IVariantConfig extends IDictionary<any> {
    captchaEnable?: boolean;
    clientId?: string;
    env?: "Development" | "UAT" | "Staging" | "Production";
    gMapCode?: string;
    gCaptchaCode?: string;
    gAnalyticsCode?: string;
    issuer?: string;
    map?: MapType;
    pspUrl?: string;
    pspUsername?: string;
    redirectUrl?: string;
    resourceName?: string;
    contentApi?: string;
    contentMedia?: string;
    fileUpload?: IFileUpload;
    //checkinInteractive?: boolean;
    underMaintenance?: boolean;
    typography?: ITypography;
}

export interface IAppConfig extends IVariantConfig {
    app: string;
    basePath: string;
    defaultBookingProvider: string;
    setting: ISetting;
    sw: string;
    transition: ITransitionConfig;
    version: IVersion;
    viewport: IViewport;
}

export const appConfig: IAppConfig = {
    // basePath: process.env.BASE_PATH as string,
    app: "ib",
    basePath: "http://localhost:3355",
    defaultBookingProvider: BookingProvider.Mahan,
    setting: {},
    sw: "service-worker",
    transition: {
        enter: 300,
        leave: 150
    },
    version: {
        api: "v1",
        app: "0.1.0"
    },
    viewport: {
        large: 1024,
        medium: 768,
        small: 576
    }
};

export const getFilePath = (key: string = "", query: boolean = false) => {
    const path = encodeURI(key);
    const width = store.getState().windowWidth;
    const orchardSupportedSizes = [16, 32, 50, 100, 160, 240, 480, 600, 1024, 1200, 2048];
    const requestSize = orchardSupportedSizes.find(x => width <= x);
    if (path)
        return query ? `${Config.config.contentMedia}/${path}?width=${requestSize}` : `${Config.config.contentMedia}/${path}`;
    return "";
}